/**
 * Loads the deploy's profile. `virtual:active-profile` is an alias the Vite config
 * points at `profiles/<VITE_PROFILE>/profile.json` (default: example) — so the chosen
 * profile is decided at build time and it is the *only* profile in the bundle. Shipping
 * a different game is a rebuild with a different env var, never a code change.
 *
 * The build refuses to start on an invalid profile (see the plugin in vite.config.ts),
 * so `parseProfile` throwing here means the build-time check was somehow bypassed —
 * fail loudly rather than render a half-built house.
 */

import { parseProfile } from './validate';
import type { Profile } from './types';

export async function loadActiveProfile(): Promise<Profile> {
  const module = await import('virtual:active-profile');
  return parseProfile(module.default);
}
